// extracted by mini-css-extract-plugin
module.exports = {"chip":"servicespage_chip__FDjYJ","fadein":"servicespage_fadein__ZwMxW","loading":"servicespage_loading__wpUOC"};